<template>
  <div>
    <div class="owner_title">我的金主</div>
    <div class="info_btn_box">
      <el-button
        type="primary"
        @click="goOwnerInfo()"
        class="iconfont icon-jiahao addInfo"
        >录入金主信息</el-button
      >
      <el-upload
        class="upload-demo"
        :action="uploadUrl"
        multiple
        :on-success="importXlsx"
        :show-file-list="false"
      >
        <el-button type="primary" plain>
          <i class="el-icon-upload"></i>
          <span>导入信息</span>
        </el-button>
      </el-upload>
    </div>

    <div class="btn_box">
      <div class="owner_status_box">
        <el-button
          class="status_btn"
          type="primary"
          :plain="btn_active == 3 ? false : true"
          @click="allOwner(3)"
          >全部</el-button
        >
        <el-button
          class="status_btn"
          type="primary"
          :plain="btn_active == 0 ? false : true"
          @click="newEntry(0)"
          >新入库</el-button
        >
        <el-button
          class="status_btn"
          type="primary"
          :plain="btn_active == 1 ? false : true"
          @click="Cooperating(1)"
          >合作中</el-button
        >
        <el-button
          class="status_btn"
          type="primary"
          :plain="btn_active == 2 ? false : true"
          @click="Cooperated(2)"
          >合作过</el-button
        >
      </div>
      <div class="filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>

    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="90px"
      >
        <el-form-item label="金主昵称" prop="name">
          <el-input v-model="filter_form.name"></el-input>
        </el-form-item>
        <el-form-item label="金主电话" prop="mobile">
          <el-input v-model="filter_form.mobile"></el-input>
        </el-form-item>
        <!-- <el-form-item label="金主状态">
          <el-select v-model="filter_form.status" placeholder="金主状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="新入库" value="0"></el-option>
            <el-option label="合作中" value="1"></el-option>
            <el-option label="合作过" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="金主微信">
          <el-input v-model="filter_form.wx_account"></el-input>
        </el-form-item>
        <el-form-item label="金主QQ">
          <el-input v-model="filter_form.qq_account"></el-input>
        </el-form-item>
        <el-form-item label="金主标签">
          <el-select
            v-model="filter_form.connectionlabel_id"
            placeholder="金主标签"
          >
            <el-option
              v-for="(item, index) in lableList"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否有任务">
          <el-select v-model="filter_form.is_task" placeholder="是否有任务">
            <el-option label="全部" value=""></el-option>
            <el-option label="无任务" value="0"></el-option>
            <el-option label="有任务" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <div class="filter_btn">
            <el-button type="primary" icon="el-icon-search" @click="goSearch"
              >搜索</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格数据 -->
    <div class="table_box">
      <el-table
        :height="equipmentType == 0 ? 500 : 800"
        :data="dataShow"
        border
        width="100%"
      >
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column
          property="name"
          label="金主昵称"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 101"
        >
        </el-table-column>
        <el-table-column
          property="mobile"
          label="金主电话号码"
          align="center"
          sortable
          :width="equipmentType == 0 ? 160 : 130"
        >
        </el-table-column>
        <el-table-column
          property="qq_account"
          label="金主QQ"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 103"
        >
        </el-table-column>
        <el-table-column
          property="wx_account"
          label="金主微信"
          align="center"
          sortable
          :width="equipmentType == 0 ? 130 : 103"
        >
        </el-table-column>
        <el-table-column
          property="status"
          label="金主状态"
          align="center"
          sortable
          :width="equipmentType == 0 ? 130 : 110"
        >
          <!-- 0=新入库红色，1=合作中蓝色，2=合作过绿色 -->
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == '0'
                  ? 'danger'
                  : scope.row.status == '2'
                  ? 'success'
                  : ''
              "
            >
              <div
                class="tag_circle"
                :class="[
                  scope.row.status == '0'
                    ? 'tag_red'
                    : scope.row.status == '2'
                    ? 'tag_green'
                    : 'tag_blue'
                ]"
              ></div>
              {{
                scope.row.status == "0"
                  ? "新入库"
                  : scope.row.status == "2"
                  ? "合作过"
                  : "合作中"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="金主标签"
          align="center"
          sortable
          :width="equipmentType == 0 ? 140 : 110"
        >
          <template slot-scope="scope">
            <el-tag
              :key="item"
              v-for="item in scope.row.connectionlabel_text"
              type="info"
              >{{ item }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          property="connectionremark_text"
          label="批注"
          align="center"
          :width="equipmentType == 0 ? '' : 80"
          sortable
        >
        </el-table-column>
        <el-table-column
          property="is_task"
          label="是否由公海转入"
          align="center"
          sortable
          :width="equipmentType == 0 ? 150 : 145"
        >
          <!-- 是否有任务:0=无任务,1=有任务  默认空 -->
          <template slot-scope="scope">
            {{ scope.row.is_high_seas == "0" ? "否" : "是" }}
          </template>
        </el-table-column>
        <el-table-column
          property="is_task"
          label="是否有任务"
          align="center"
          sortable
          :width="equipmentType == 0 ? 120 : 120"
        >
          <!-- 是否有任务:0=无任务,1=有任务  默认空 -->
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_task == '1' ? 'info' : ''">
              {{ scope.row.is_task == "0" ? "无任务" : "有任务" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          :width="equipmentType == 0 ? 180 : 110"
        >
        </el-table-column>
        <el-table-column
          :fixed="equipmentType == 1 ? false : 'right'"
          label="操作"
          align="center"
          :width="table_width"
        >
          <template slot-scope="scope">
            <div class="owner_box" v-if="scope.row.status == 0">
              <div
                @click="goCooperation(scope.$index, scope.row)"
                class="owner_item_btn"
              >
                转化合作
              </div>
              <div @click="editOwner(scope.row)" class="edit_btn">
                <i class="el-icon-edit-outline"></i>
                修改
              </div>
              <div @click="addLabel(scope.row)" class="edit_btn">
                <i class="el-icon-circle-plus-outline"></i>
                标签
              </div>
              <div @click="addRemarkDialog(scope.row)" class="edit_btn  ">
                <i class="el-icon-circle-plus-outline"></i>
                批注
              </div>
            </div>
            <div class="owner_btn_box" v-else>
              <div @click="goDemand(scope.row)" class="demandBtn">
                <i class="upload_icon iconfont icon-shangchuan"></i>
                录入需求
              </div>
              <div @click="editOwner(scope.row)" class="edit_demand">
                <i class="el-icon-edit-outline"></i>
                修改
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加标签弹窗 -->
    <el-dialog
      title="添加标签"
      :visible.sync="tagDialogVisible"
      :width="equipmentType == 0 ? '30% ' : '90%'"
      center
    >
      <el-form :model="tagForm" :rules="rules">
        <el-form-item label="添加标签:">
          <el-checkbox-group class="checkbox" v-model="checkedLabels">
            <el-checkbox
              @change="handleCheckedLabel(item)"
              class="checkbox"
              v-for="item in lableList"
              :key="item.name"
              :label="item.name"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="handleAdd"
          >确认添加</el-button
        >
        <el-button class="dialog_btn" round @click="tagDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <!-- 添加批注弹窗 -->
    <el-dialog
      title="添加批注"
      :visible.sync="remarkDialogVisible"
      :width="equipmentType == 0 ? '30% ' : '90%'"
      center
    >
      <el-form :model="remarkForm" ref="remarkForm">
        <el-form-item label="添加批注:" prop="connectionremark_text">
          <el-input
            v-model="remarkForm.connectionremark_text"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog_btn"
          round
          type="primary"
          @click="handleSetRemark()"
          >确认添加</el-button
        >
        <el-button class="dialog_btn" round @click="remarkDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <el-pagination
      v-show="equipmentType == 0 ? true : false"
      class="pagination_box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <el-pagination
      v-show="equipmentType == 1 ? true : false"
      class="pagination_box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  owner_list,
  add_label,
  label_list,
  add_remark,
  transformation_cooperation
} from "@/utils/owner";
import { import_xlsx } from "@/utils/api";
let previousRouterName = "";
let filter_obj = "";
let isActive = "";
let cancel_tag = "";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl, //文件上传路径
      ownerId: "", //所属金主部id
      ownerList: [], //金主列表数据
      connectionlabel_text: null, //金主标签
      isFilterForm: true, //筛选表单
      selectLabelList: [], //选中标签值的列表
      tagDialogVisible: false, //标签弹窗
      remarkDialogVisible: false, //批注弹窗
      rules: {
        labels: [{ required: true, message: "请选择标签", trigger: "blur" }]
      },
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      // 筛选
      filter_form: {
        name: "", //金主昵称
        qq_account: "", //金主QQ
        wx_account: "", //金主微信
        mobile: "", //金主电话号码
        status: "", //金主状态 默认0  0=新入库,1=合作中,2=合作过
        createtime: "", //创建时间范围
        is_task: "", //是否有任务:0=无任务,1=有任务  默认空
        connectionlabel_id: "" //标签
      },
      // 批注表单
      remarkForm: {
        departmentuser_id: "",
        connection_id: "",
        connectionremark: ""
      },
      lableList: "", //标签列表
      // 标签表单
      tagForm: {
        departmentuser_id: "",
        connection_id: "",
        connectionlabel_ids: ""
      },
      checkedLabels: [], //选择标签数据
      isCooperate: 0, //是否合作
      btn_active: 0, //金主的默认状态
      table_width: 350, //操作栏默认宽度
      mobileTable: "auto", //移动端表格高度
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //设备 0-pc端 1移动端
    };
  },
  beforeRouteEnter(to, from, next) {
    previousRouterName = from.path;
    cancel_tag = from.params.edit_id;
    if (from.path === "/ownerEdit") {
      if (from.params.edit_id == 1) {
        filter_obj = JSON.stringify(from.params.filter);
        isActive = JSON.stringify(from.params.active);
      } else {
        filter_obj = JSON.stringify(from.params.filter);
        isActive = JSON.stringify(from.params.active);
      }
    }
    next();
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;

    if (this.$isMobile.isDeviceType()) {
      //  手机端
      // console.log("手机端");
      this.equipmentType = 1;
    } else {
      //  pc端
      // console.log("pc端");
      this.equipmentType = 0;
    }
    this.getLabelList();
    if (previousRouterName === "/ownerEdit") {
      this.table_width = "200";

      var obj_data = JSON.parse(filter_obj);

      this.filter_form = obj_data;
      let obj;
      if (cancel_tag == 1) {
        obj = {
          departmentuser_id: this.ownerId,
          ...obj_data,
          status: isActive
        };
      } else {
        console.log("****", obj_data);
        if (obj_data.createtime == "") {
          obj = {
            departmentuser_id: this.ownerId,
            ...obj_data,
            status: isActive
          };
        } else {
          var createTimeData =
            obj_data.createtime[0] + " - " + obj_data.createtime[1];
          obj = {
            departmentuser_id: this.ownerId,
            ...obj_data,
            createtime: createTimeData,
            status: isActive
          };
        }
      }

      owner_list(obj).then(res => {
        if (res.data.code == 1) {
          this.total = res.data.data.length;
          this.ownerList = res.data.data;
          this.ownerList.forEach(item => {
            this.connectionlabel_text = item.connectionlabel_text[0];
          });
          this.calcPageData();
        } else {
          this.$message.error(res.data.msg);
        }
      });
      this.btn_active = isActive;
    } else {
      this.newEntry(0);
    }
  },
  methods: {
    // 获取金主列表
    getOwnerList(val) {
      var that = this;
      var status_val;
      if (val == 3) {
        status_val = " ";
      } else {
        status_val = val;
      }
      let obj = {
        departmentuser_id: that.ownerId,
        status: status_val,
        page: 1,
        page_index: 10
      };
      owner_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.ownerList = res.data.data;
          that.ownerList.forEach(item => {
            that.connectionlabel_text = item.connectionlabel_text[0];
          });
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 全部
    allOwner() {
      var that = this;
      that.btn_active = 3;
      that.table_width = 350;
      that.getOwnerList();
    },
    // 新入库
    newEntry(val) {
      var that = this;
      that.btn_active = 0;
      that.table_width = 350;
      console.log("新入库", that.btn_active);
      that.getOwnerList(val);
    },
    // 合作中
    Cooperating(val) {
      var that = this;
      that.btn_active = 1;
      that.table_width = 200;
      that.getOwnerList(val);
    },
    // 合作过
    Cooperated(val) {
      var that = this;
      that.btn_active = 2;
      that.table_width = 200;
      that.getOwnerList(val);
    },
    // 导入xlsx文件
    importXlsx(val) {
      var that = this;
      let obj = {
        file: val.data.url
      };
      import_xlsx(obj).then(res => {
        if (res.data.code == 1) {
          that.getOwnerList(0);
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    goSearch(val) {
      var that = this;
      var date1, date2;
      that.select_time_data = that.filter_form.createtime;

      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
      } else {
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        that.filter_form.createtime = that.time_filter;
      }
      var status_val;
      if (that.btn_active == 3) {
        status_val = "";
      } else {
        status_val = that.btn_active;
      }
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10,
        ...that.filter_form,
        status: status_val
      };
      owner_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.ownerList = res.data.data;
          that.filter_form.createtime = that.select_time_data;
          that.ownerList.forEach(item => {
            that.connectionlabel_text = item.connectionlabel_text[0];
          });
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    calcPageData() {
      if (this.ownerList.length > 1) {
        this.pageNum = Math.ceil(this.ownerList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.ownerList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    },
    //打开弹窗获取标签列表
    addLabel(val) {
      var that = this;
      that.tagForm.connection_id = val.id;
      that.tagDialogVisible = true;
      that.getLabelList();
      //初始化选中标签id，名字
      let labelsId = [];
      if (val.connectionlabel_ids != null) {
        labelsId = val.connectionlabel_ids.split(",");
      }
      let labelsName = [];
      Object.values(that.lableList).forEach(item => {
        if (labelsId.includes(String(item.id))) {
          labelsName.push(item.name);
        }
      });
      that.checkedLabels = labelsName;
      that.selectLabelList = labelsId;
    },
    // 获取标签列表
    getLabelList() {
      var that = this;
      label_list().then(res => {
        if (res.data.code == 1) {
          that.lableList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 选中标签
    handleCheckedLabel(val) {
      var that = this;
      let _id = String(val.id);
      // 判断选中的标签是否在选中标签数组中
      if (that.selectLabelList.includes(_id)) {
        that.selectLabelList = that.selectLabelList.filter(item => item != _id);
      } else {
        that.selectLabelList.push(_id);
      }
      that.tagForm.connectionlabel_ids = that.selectLabelList.join(",");
    },
    // 确认添加标签
    handleAdd() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connection_id: that.tagForm.connection_id,
        connectionlabel_ids: that.tagForm.connectionlabel_ids
      };
      add_label(obj).then(res => {
        if (res.data.code == 1) {
          that.tagDialogVisible = false;
          that.goSearch();
          // that.newEntry(0);
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 打开添加批注弹窗
    addRemarkDialog(row) {
      var that = this;
      that.remarkDialogVisible = true;
      that.remarkForm = { ...row };
    },
    // 确认添加批注
    handleSetRemark() {
      var that = this;
      var currentId = that.remarkForm.id;
      let obj = {
        departmentuser_id: that.ownerId,
        connection_id: currentId,
        connectionremark: that.remarkForm.connectionremark_text
      };
      add_remark(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          that.remarkDialogVisible = false;
          that.goSearch();
          // that.newEntry(0);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 录入金主信息
    goOwnerInfo() {
      var that = this;
      that.$router.push("/ownerInfo");
    },
    // 转化合作
    goCooperation(index, val) {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connection_id: val.id
      };
      transformation_cooperation(obj).then(res => {
        if (res.data.code == 1) {
          that.isCooperate = index;
          that.Cooperating(1);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 录入需求
    goDemand(val) {
      var that = this;
      that.$router.push({
        path: "ownerDemand",
        query: {
          connection_id: val.id,
          connection_expand_id: val.connection_expand_id
        }
      });
    },
    //修改金主信息
    editOwner(val) {
      var that = this;
      localStorage.setItem("btn_active", that.btn_active);
      localStorage.setItem("filter_form", that.filter_form);
      let data = JSON.stringify(val);
      let filter = JSON.stringify(that.filter_form);
      that.$router.push(
        "/ownerEdit?data=" +
          data +
          "&active=" +
          that.btn_active +
          "&filter=" +
          filter
      );
    }
  }
};
</script>
<style scoped>
.el-input__inner {
  background-color: RGB(250, 250, 250);
}
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.info_btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/* 筛选表单 */
.filter_form {
  /* width: 1655px; */
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.addInfo {
  margin: 15px 15px 10px 15px;
}
.addInfo,
.filtrate i {
  font-size: 14px;
}
.filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.filtrate {
  margin-right: 25px;
}
.table_box {
  margin: 0px 15px;
}
.owner_btn_box {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
}
.edit_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  color: #157df8;
  border-radius: 10px;
  margin: 0px 5px;
  font-size: 12px;
}
.edit_demand {
  width: 75px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  color: #157df8;
  border-radius: 10px;
  margin: 0px 5px;
  font-size: 12px;
}
.tag_circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;

  margin-right: 5px;
}
.tag_red {
  background: #f56c6c;
}
.tag_blue {
  background: #409eff;
}
.tag_green {
  background: #67c23a;
}
.owner_item_btn {
  width: 117px;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.el-dialog__header {
  background: #157df8;
}
.el-dialog__title {
  color: #fff;
}

.el-dialog--center .el-dialog__body {
  padding: 25px 70px 30px;
}
.dialog-footer .dialog_btn {
  width: 200px;
  height: 35px;
}
.checkbox {
  display: table-row-group;
}
.demandBtn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  text-align: center;
  background: #157df8;
  color: #fff;
  font-size: 12px;
}
.demandBtn i {
  font-size: 12px;
}
.table_box .el-tag {
  width: 90px;
  margin: 5px auto;
}
.owner_box {
  display: flex;
  flex-direction: row;
}
.owner_status_box {
  display: flex;
  flex-direction: row;
  margin: 0px 0px 10px 15px;
}
.status_btn {
  /* width: 100px;
  height: 30px;
  line-height: 7px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-right: 5px;
  border: none; */
  width: 100px;
  height: 30px;
  line-height: 7px;
  border-radius: 4px;
  border: none;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .status_btn {
    width: 80px;
    height: 30px;
    line-height: 7px;
    border-radius: 4px;
    border: none;
  }
  .filter_btn {
    margin-left: 30px;
    padding-bottom: 5px;
  }
  /* .el-select {
    width: 180px !important;
  } */
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 210px !important;
  }
  .table_box .el-tag {
    width: 70px;
    margin: 5px auto;
  }
  .table_box {
    margin-bottom: 150px;
  }
  /* .owner_box {
    display: flex;
    flex-direction: column;
  } */
  /* .owner_btn_box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  } */
  .demandBtn,
  .edit_btn {
    margin-bottom: 5px;
  }
  .owner_item_btn {
    width: 95px;
    margin-bottom: 5px;
  }
}
</style>
<style>
@media screen and (max-width: 750px) and (min-width: 375px) {
  /* .el-picker-panel {
    width: 372px !important;
  }
  .el-date-range-picker .el-picker-panel__body {
    min-width: 373px !important;
  }
  .el-date-range-picker__content .el-date-range-picker__header div {
    margin-left: 0 !important;
    margin-right: 15px !important;
  } */
  /* .el-input__inner {
    padding: 0px 3px !important;
  }
  .el-date-editor .el-range-input {
    width: 70% !important;
  } */
}
</style>



// WEBPACK FOOTER //
// src/view/owner/MyOwner.vue